import { createAction } from '@reduxjs/toolkit';

import { getFailurePayload, getRequestPayload, getSuccessPayload } from 'modules/utils';

import * as actionTypes from '../actionTypes';

export const sendOpinion = createAction(actionTypes.SEND_OPINION, (url, opinion) => ({
  payload: {
    request: {
      method: 'POST',
      url,
      data: { opinion },
    },
  },
  meta: {},
}));
export const sendOpinionSuccess = createAction(actionTypes.SEND_OPINION_SUCCESS, getSuccessPayload);
export const sendOpinionFailure = createAction(actionTypes.SEND_OPINION_FAILURE, getFailurePayload);

export const callMeBack = createAction(actionTypes.CALL_ME_BACK, getRequestPayload({ method: 'POST' }));
export const callMeBackSuccess = createAction(actionTypes.CALL_ME_BACK_SUCCESS, getSuccessPayload);
export const callMeBackFailure = createAction(actionTypes.CALL_ME_BACK_FAILURE, getFailurePayload);

export const downloadMedias = createAction(actionTypes.DOWNLOAD_MEDIAS, url => ({
  payload: {
    request: {
      url,
      method: 'POST',
    },
  },
}));
export const downloadMediasSuccess = createAction(actionTypes.DOWNLOAD_MEDIAS_SUCCESS);
export const downloadMediasFailure = createAction(actionTypes.DOWNLOAD_MEDIAS_FAILURE, getFailurePayload);

export const getZipMedias = createAction(actionTypes.GET_ZIP_MEDIAS, url => ({
  payload: {
    request: {
      method: 'GET',
      url,
    },
  },
}));
export const getZipMediasSuccess = createAction(actionTypes.GET_ZIP_MEDIAS_SUCCESS, path => ({
  payload: path,
}));
export const getZipMediasFailure = createAction(actionTypes.GET_ZIP_MEDIAS_FAILURE, getFailurePayload);

export const getPdfOffer = createAction(actionTypes.FETCH_PDF_OFFER, (url, filename) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return {
    payload: {
      request: {
        url: `${url}&timezone=${timezone}`,
        method: 'GET',
      },
      filename,
    },
  };
});

export const getPdfOfferSuccess = createAction(actionTypes.FETCH_PDF_OFFER_SUCCESS);
export const getPdfOfferFailure = createAction(actionTypes.FETCH_PDF_OFFER_FAILURE, getFailurePayload);

/**
 * @param {string} url
 * @param {import('../types').ContactFormData} data
 * @returns {import('../types').SendContactFormAction}
 */
export const sendContactForm = createAction(actionTypes.SEND_CONTACT_FORM, (url, data) => ({
  payload: {
    request: {
      method: 'POST',
      url,
      data,
    },
  },
}));

/**
 * @returns {import('../types').SendContactFormSuccessAction}
 */
export const sendContactFormSuccess = createAction(actionTypes.SEND_CONTACT_FORM_SUCCESS, intervention => ({
  payload: intervention,
}));

/**
 * @returns {import('../types').SendContactFormFailureAction}
 */
export const sendContactFormFailure = createAction(actionTypes.SEND_CONTACT_FORM_FAILURE, getFailurePayload);

export const resetContactForm = createAction(actionTypes.RESET_CONTACT_FORM);

/**
 * @returns {import('../types').SetControlReportFilterAction}
 */
export const setControlReportFilter = createAction(actionTypes.SET_CONTROL_REPORT_FILTER, value => ({
  payload: value,
}));
